import { render, staticRenderFns } from "./OrderableProductCustomPriceInputs.vue?vue&type=template&id=0f5dc6fd&"
import script from "./OrderableProductCustomPriceInputs.vue?vue&type=script&lang=ts&"
export * from "./OrderableProductCustomPriceInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports